import { render, staticRenderFns } from "./InvitationSentDialog.vue?vue&type=template&id=3885d135&"
import script from "./InvitationSentDialog.vue?vue&type=script&lang=js&"
export * from "./InvitationSentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports